export default __webpack_public_path__ + "static/media/mouse-button.26611f68.svg";